export default __webpack_public_path__ + "static/IMG_2260-440629665ae227710ae00c85dbd39ed8.jpg";